import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { View } from 'foundations-components/transitional/components/View';
import { createToObject } from 'pricing-pages-lib/utils/queryParamUtils';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { PROFESSIONAL } from 'self-service-api/constants/ProductLevels';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { HUBSPOT_CREDITS_VALUE_PROPOSITIONS } from '../../constants/tracking/TrackingSources';
import { useMedia } from '../../hooks/useMedia';
import { useAppSelector } from '../../reducers';
import { hasProductLevelOrHigherInProductInventorySelector, ownedHubSpotCreditsTotalSelector } from '../../selectors/ProductInventorySelectors';
import { trackClickedLink } from '../../utils/tracking/trackingEventUtils';
import BuyMoreCredits from './BuyMoreCredits';
import ValuePropositionsUpgradeCard from './ValuePropositionsUpgradeCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Bold = props => /*#__PURE__*/_jsx(Text, {
  as: "span",
  typography: "heading-50",
  children: props.children
});
const LinkWithTracking = props => {
  const to = createToObject('/service');
  const handleLinkClick = () => {
    trackClickedLink({
      type: 'internal',
      url: '/service',
      trackingSource: HUBSPOT_CREDITS_VALUE_PROPOSITIONS,
      value: 'Service Hub Professional'
    });
  };
  return /*#__PURE__*/_jsx(RouterLink, {
    to: to,
    onClick: handleLinkClick,
    children: props.children
  });
};
const HubSpotCreditsValuePropositions = ({
  screen
}) => {
  const isMaxWidthTablet = useMedia('tablet');
  const ownsAdditionalCredits = useAppSelector(state => {
    const ownedQuantity = ownedHubSpotCreditsTotalSelector(state);
    return ownedQuantity && ownedQuantity > 0;
  });
  const ownsProOrHigher = useAppSelector(state => {
    return hasProductLevelOrHigherInProductInventorySelector(state, {
      productLevel: PROFESSIONAL
    });
  });
  return /*#__PURE__*/_jsx(PageSection, {
    children: /*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      gap: "800",
      flexDirection: isMaxWidthTablet ? 'column' : 'row',
      alignItems: "center",
      children: [/*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        gap: "600",
        children: [/*#__PURE__*/_jsx(View, {
          maxInlineSize: "75ch",
          children: /*#__PURE__*/_jsx(Text, {
            as: "h2",
            typography: "heading-400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricingPage.pages.hubspot-credits.info.banner.title"
            })
          })
        }), /*#__PURE__*/_jsxs(List, {
          styled: true,
          children: [/*#__PURE__*/_jsx(ListItem, {
            children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: "pricingPage.pages.hubspot-credits.info.banner.valueProps.humanLikeInteractions_jsx",
              elements: {
                Bold
              }
            })
          }), /*#__PURE__*/_jsx(ListItem, {
            children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: "pricingPage.pages.hubspot-credits.info.banner.valueProps.trainInMinutes_jsx",
              elements: {
                Bold
              }
            })
          }), /*#__PURE__*/_jsx(ListItem, {
            children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: "pricingPage.pages.hubspot-credits.info.banner.valueProps.handleRoutineQueries_jsx",
              elements: {
                Bold
              }
            })
          }), /*#__PURE__*/_jsx(ListItem, {
            children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: "pricingPage.pages.hubspot-credits.info.banner.valueProps.monitorPerformance_jsx",
              elements: {
                Bold
              }
            })
          })]
        }), /*#__PURE__*/_jsx(Flex, {
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "pricingPage.pages.hubspot-credits.info.banner.footer_jsx",
            elements: {
              Link: LinkWithTracking
            }
          })
        })]
      }), ownsAdditionalCredits && ownsProOrHigher ? /*#__PURE__*/_jsx(BuyMoreCredits, {
        trackingSource: HUBSPOT_CREDITS_VALUE_PROPOSITIONS,
        screen: screen
      }) : /*#__PURE__*/_jsx(ValuePropositionsUpgradeCard, {
        trackingSource: HUBSPOT_CREDITS_VALUE_PROPOSITIONS
      })]
    })
  });
};
export default HubSpotCreditsValuePropositions;